import type {
  DocumentsResponse,
  PlanLink,
  PlanResponse,
} from "@Light/services/lightTypes";

type DocumentUrls = Pick<DocumentsResponse, "efl" | "tos" | "yrac">;

// `documents` is not in the published API schema yet, so it is declared here.
type DocumentsWithLinks = DocumentsResponse & {
  documents?: PlanLink[] | null;
};

const defaultPlanLinks = ({ efl, tos, yrac }: DocumentUrls): PlanLink[] => [
  {
    name: "Electricity Facts Label",
    short_name: "EFL",
    url: efl,
  },
  {
    name: "Terms of Service",
    short_name: "Terms of Service",
    url: tos,
  },
  {
    name: "Your Rights as a Customer",
    short_name: "YRAC",
    url: yrac,
  },
];

/** The plan's `plan_links`, or the same list built from `links` when absent. */
export function getPlanLinks(
  rate: Pick<PlanResponse, "links" | "plan_links">,
): PlanLink[] {
  return rate.plan_links ?? defaultPlanLinks(rate.links);
}

/** The contract's `documents`, or the same list built from its URLs when absent. */
export function getDocumentLinks(documents: DocumentsWithLinks): PlanLink[] {
  return documents.documents ?? defaultPlanLinks(documents);
}
